import { combineReducers } from "redux";
import authReducer from "./authReducer";
import groupReducer from "./groupsReducer";
import loyaltyReducer from "./loyaltyReducer";
import cashierReducer from "./cashierReducer";
import storeSetupReducer from "./storesReducer";
import dashboardReducer from "./dashboardReducer";
import userOnBoardReducer from "./userOnBoardReducer";
import custInsightReducer from "./custInsightReducer.js";
import shortLinkReducer from "./shortLinkReducer";
import campaignsReducer from "./campaignsReducer.js";
import campaignsUnpersistedReducer from "./campaignsUnpersistedReducer";
import integrationReducer from "./integrationReducer";
import { reducer as toastrReducer } from "react-redux-toastr";
import paymentReducer from "./paymentReducer";
import channelsReducer from "./channelsReducer";
import feedBackReducer from "./feedbackReducer";
import autoEngageReducer from "./autoEngageReducer";
import productTourReducer from "./productTourReducer";
import qrCodeReducer from "./qrCodeReducer";
import b2cReducer from "./b2cReducer";
import waChatReducer from "./waChatReducer";
import membershipReducer from "./membershipReducer";
import audienceRecommendationReducer from "./audienceRecommendationReducer";

export default combineReducers({
  auth: authReducer,
  group: groupReducer,
  store: storeSetupReducer,
  loyalty: loyaltyReducer,
  toastr: toastrReducer,
  cashierRoot: cashierReducer,
  dashboard: dashboardReducer,
  userOnboard: userOnBoardReducer,
  custInsights: custInsightReducer,
  shortLink: shortLinkReducer,
  campsRoot: campaignsReducer,
  campsUnPersRoot: campaignsUnpersistedReducer,
  integration: integrationReducer,
  payments: paymentReducer,
  channels: channelsReducer,
  feedback: feedBackReducer,
  autoCamps: autoEngageReducer,
  productTour: productTourReducer,
  qr: qrCodeReducer,
  b2c: b2cReducer,
  waChat: waChatReducer,
  membership: membershipReducer,
  audienceRecs: audienceRecommendationReducer,
});

